import type { SVGProps } from "react";

export function YouTube(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M3.40334 18.9389C5.11757 19.3983 12 19.3983 12 19.3983C12 19.3983 18.8824 19.3983 20.5967 18.9389C21.5452 18.6837 22.2897 17.9393 22.5406 16.995C23 15.2807 23 11.6992 23 11.6992C23 11.6992 23 8.11756 22.5406 6.40332C22.2897 5.45475 21.541 4.71037 20.5967 4.4594C18.8824 4.00001 12 4 12 4C12 4 5.11757 4.00001 3.40334 4.4594C2.45477 4.71037 1.71035 5.45901 1.45938 6.40332C0.999981 8.11756 1 11.6992 1 11.6992C1 11.6992 0.999981 15.2807 1.45938 16.995C1.70609 17.9393 2.45477 18.6837 3.40334 18.9389ZM9.79657 8.39405L15.5135 11.6949L9.79657 14.9958V8.39405Z"
        fill="currentColor"
      />
    </svg>
  );
}
